// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2aACw","Label":"Input_Label__1hFAy","InputElement":"Input_InputElement__3oFt-","Invalid":"Input_Invalid__rcvsb"};